import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { UserAuth } from "../../authContext";
import { TiHome } from "react-icons/ti";
import { SlCalender } from "react-icons/sl";
import { GrProjects } from "react-icons/gr";
import { FaMicrochip, FaDollarSign, FaBusinessTime } from "react-icons/fa";
import { BsTools } from "react-icons/bs";
import { TbBrandBooking } from "react-icons/tb";
import { LuLogOut } from "react-icons/lu";
import { MdAccountCircle, MdManageAccounts } from "react-icons/md";
import { IoMenu, IoPersonSharp } from "react-icons/io5";
import { TiUserAdd } from "react-icons/ti";
import './Sidebar.css';
import { RiProgress6Line } from "react-icons/ri";
import { MdChecklist } from "react-icons/md";

const NavBars = () => {
    const { user, logOut } = UserAuth();
    const navigate = useNavigate();
    const location = useLocation();  // Get current route
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLeader, setIsLeader] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                const storedUser = JSON.parse(localStorage.getItem('user'));
                const storedIsAdmin = localStorage.getItem('isAdmin') === 'true';
                const storedIsLeader = localStorage.getItem('isLeader') === 'true';

                if (storedUser && storedUser.email === user?.email) {
                    setIsAdmin(storedIsAdmin);
                    setIsLeader(storedIsLeader);
                } else {
                    setIsAdmin(false);
                }
            } catch (error) {
                console.error("Failed to fetch admin status:", error);
                setIsAdmin(false);
            } finally {
                setLoading(false);
            }
        };

        if (user) {
            checkAdminStatus();
        } else {
            setLoading(false);
        }
    }, [user]);

    const handleSignOut = async () => {
        try {
            await logOut();
            navigate('/login');
        } catch (error) {
            console.log(error);
        }
    };

    // Function to check if the current route matches the menu item
    const isActive = (path) => location.pathname === path ? "active-menu" : "";

    const menuItems = [
        { path: "/home", icon: <TiHome />, text: 'Home' },
        { path: "/calender", icon: <SlCalender />, text: 'Calendar' },
        { path: "/projects", icon: <GrProjects />, text: 'Projects' },
        { path: "/items", icon: <FaMicrochip />, text: 'Items Inventory' },
        { path: "/tools", icon: <BsTools />, text: 'Available Tools' },
        { path: "/request", icon: <FaDollarSign />, text: 'Purchase Request' },
        { path: "/booking", icon: <TbBrandBooking />, text: 'Book Lab' }
    ];

    
    const leaderMenuItems = [
        { path: "/admin", icon: <TiUserAdd />, text: 'Requests' },
        { path: "/viewBooking", icon: <FaBusinessTime />, text: 'Review Booking' },
        { path: "/tasks", icon: <MdChecklist />, text: 'Tasks' }
    ]

    const adminMenuItems = [
        { path: "/manageUsers", icon: <MdManageAccounts />, text: 'Manage Users' },
        { path: "/progress", icon: <RiProgress6Line />, text: 'View Progress' },
        
    ];
    const topItems = [
        { path: "/account", icon: <MdAccountCircle />, text: 'Account' },
        { icon: <LuLogOut onClick={handleSignOut} />, text: 'Log out' },
    ];

    return (
        <div className="container">
            <div className="wrapper side">
                <IoMenu className="menu" />
                {loading ? (
                    <div>Loading...</div> // Replace with a spinner if needed
                ) : (
                    <>
                        {menuItems.map((item, index) => (
                            <div key={index} className={`menu-item ${isActive(item.path)}`}>
                                <Link to={item.path}>
                                    <div className="icon">{item.icon}</div>
                                </Link>
                                <div className="text">{item.text}</div>
                            </div>
                        ))}
                        {(isLeader) && leaderMenuItems.map((item, index) => (
                            <div key={index} className={`menu-item ${isActive(item.path)}`}>
                                <Link to={item.path}>
                                    <div className="icon">{item.icon}</div>
                                </Link>
                                <div className="text">{item.text}</div>
                            </div>
                        ))}
                        {(isAdmin) && adminMenuItems.map((item, index) => (
                            <div key={index} className={`menu-item ${isActive(item.path)}`}>
                                <Link to={item.path}>
                                    <div className="icon">{item.icon}</div>
                                </Link>
                                <div className="text">{item.text}</div>
                            </div>
                        ))}
                    </>
                )}
            </div>
            <div className="wrapper top">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        {topItems.map((item, index) => (
                            <div key={index} className={`menu-item ${isActive(item.path)}`}>
                                <div className="icon">{item.icon}</div>
                                <div className="text">{item.text}</div>
                            </div>
                        ))}
                        <Link to="/home">
                            <img src="Logo.png" className="logo" alt="Logo" />
                        </Link>
                        <a className="club name" href="/">- RAZE Portal</a>
                    </>
                )}
            </div>
        </div>
    );
};

export default NavBars;
